import { Controller } from "@hotwired/stimulus"

// Scrolls to the element with the given id and focuses its first field, without
// touching the URL. An in-page `href="#id"` cannot do this inside a Turbo frame
// in a modal: the fragment navigation reaches Turbo (frame-missing → a full
// visit) and the modal is gone. Used by the income tax guardian's "fill in the
// facts" link (workspaces/income_tax_guardian/_content).
export default class extends Controller {
  static values = { target: String }

  scroll(event) {
    event.preventDefault()
    const target = document.getElementById(this.targetValue)
    if (!target) return

    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
    target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" })
    target.querySelector("input:not([type=hidden]), select, textarea")?.focus({ preventScroll: true })
  }
}
